import React from 'react';
import type { PlaybookDiff } from '../../types/playbook.types';

interface DiffSummaryBarProps {
  diff: PlaybookDiff;
  onExit: () => void;
}

const DiffSummaryBar: React.FC<DiffSummaryBarProps> = ({ diff, onExit }) => {
  const s = diff.summary;
  return (
    <div className="flex items-center gap-3 rounded-lg border border-violet-200 dark:border-violet-700 bg-violet-50/50 dark:bg-violet-900/10 px-3 py-1.5">
      <span className="text-[10px] font-semibold text-violet-600 dark:text-violet-400 uppercase">Diff</span>
      <span className="text-[10px] text-gray-500 dark:text-gray-400">
        v{diff.sourceVersion} → v{diff.targetVersion}
      </span>
      <div className="flex items-center gap-2 text-[10px]">
        {s.statusesAdded > 0 && <span className="text-emerald-600 dark:text-emerald-400">+{s.statusesAdded} statuses</span>}
        {s.statusesRemoved > 0 && <span className="text-rose-600 dark:text-rose-400">-{s.statusesRemoved} statuses</span>}
        {s.statusesModified > 0 && <span className="text-amber-600 dark:text-amber-400">~{s.statusesModified} statuses</span>}
        {s.transitionsAdded > 0 && <span className="text-emerald-600 dark:text-emerald-400">+{s.transitionsAdded} transitions</span>}
        {s.transitionsRemoved > 0 && <span className="text-rose-600 dark:text-rose-400">-{s.transitionsRemoved} transitions</span>}
        {s.transitionsModified > 0 && <span className="text-amber-600 dark:text-amber-400">~{s.transitionsModified} transitions</span>}
      </div>
      <div className="flex-1" />
      <button type="button" onClick={onExit} className="rounded border border-violet-300 px-2 py-0.5 text-[10px] font-medium text-violet-600 hover:bg-violet-100 dark:border-violet-600 dark:text-violet-400 dark:hover:bg-violet-900/30">
        Exit Diff
      </button>
    </div>
  );
};

export default DiffSummaryBar;
